import { Link, useLocation } from 'react-router-dom';
import { Terminal, Zap, LayoutDashboard } from 'lucide-react';
import { cn } from '@/lib/utils';

const links = [
  { to: '/debug', icon: LayoutDashboard, label: 'Overview' },
  { to: '/debug/backend', icon: Terminal, label: 'Backend' },
  { to: '/debug/execution', icon: Zap, label: 'Execution' },
];

export function DebugNav() {
  const { pathname } = useLocation();

  return (
    <nav className="flex items-center gap-1 rounded-lg border border-border bg-muted/40 p-1 text-sm">
      {links.map(({ to, icon: Icon, label }) => {
        const active = pathname === to;
        return (
          <Link
            key={to}
            to={to}
            className={cn(
              'flex items-center gap-1.5 rounded-md px-3 py-1.5 transition-colors',
              active
                ? 'bg-background text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground hover:bg-background/50'
            )}
          >
            <Icon className="w-3.5 h-3.5" />
            {label}
          </Link>
        );
      })}
    </nav>
  );
}
